// hotel_collect,channel_collect

export const BookingPayment = [
    { value: 'hotel_collect', label: 'Hotel Collect' },
    { value: 'channel_collect', label: 'Channel Collect' },
    { value: '', label: 'Not Set' },
]

export type BookingPaymentType = typeof BookingPayment[number]['value']